import { render, staticRenderFns } from "./VendorTermsOfServiceModal.vue?vue&type=template&id=6f9b0c72"
import script from "./VendorTermsOfServiceModal.vue?vue&type=script&lang=js"
export * from "./VendorTermsOfServiceModal.vue?vue&type=script&lang=js"
import style0 from "./VendorTermsOfServiceModal.vue?vue&type=style&index=0&id=6f9b0c72&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports